import { url } from '../utils';

const authRoutes = {
  companyLaunchpad: url('/company/launchpad/'),
  companySetActiveAccountCompanyDetail: url<{ lang: string, companyId: string }>('/:lang/company/set-active-account/:companyId/'),
  companyInvitationAcceptInvitationDetail: url<{ lang: string, invitationId: string }>('/:lang/company/invitation-accept/:invitationId/'),
  companyInvitationExpired: url<{ lang: string }>('/:lang/company/invitation-expired/'),
  authLogin: url<{ lang: string }>('/:lang/auth/login/'),
  authLogout: url<{ lang: string }>('/:lang/auth/logout/'),
  authPasswordReset: url<{ lang: string }>('/:lang/auth/password_reset/'),
  authResetUidb64Token: url<{ lang: string, uidb64: string, token: string }>('/:lang/auth/reset/:uidb64/:token/'),
  onboarding: url<{ lang: string }>('/:lang/onboarding/'),
  onboardingPlatformIntegrationPlatformIntegrationDetail: url<{ lang: string, platformIntegrationId: string }>('/:lang/onboarding/platform-integration/:platformIntegrationId/'),
  onboardingPlatformIntegrationPlatformIntegrationIdCompleted: url<{ lang: string, platformIntegrationId: string }>('/:lang/onboarding/platform-integration/:platformIntegrationId/completed/'),
  onboardingShoptetDisplayEmailPlatformIntegrationDetail: url<{ lang: string, platformIntegrationId: string }>('/:lang/onboarding/shoptet/display-email/:platformIntegrationId/'),
}

export default authRoutes;
